const languageData = [
    {
        languageId: 'german',
        locale: 'de',
        name: 'Deutsch',
        icon: 'de'
    },
    {
        languageId: 'english',
        locale: 'en',
        name: 'English',
        icon: 'us'
    }/*,
    {
        languageId: 'spanish',
        locale: 'es',
        name: 'Español',
        icon: 'es'
    },
    {
        languageId: 'french',
        locale: 'fr',
        name: 'Français',
        icon: 'fr'
    },
    {
        languageId: 'polish',
        locale: 'pl',
        name: 'Polski',
        icon: 'pl'
    },
    {
        languageId: 'russian',
        locale: 'ru',
        name: 'Pусский',
        icon: 'ru'
    },
    {
        languageId: 'turkish',
        locale: 'tr',
        name: 'Türk',
        icon: 'tr'
    }*/
    
    /*,
    {
        languageId: 'chinese',
        locale: 'zh',
        name: 'Chinese',
        icon: 'cn'
    },
    {
        languageId: 'spanish',
        locale: 'es',
        name: 'Spanish',
        icon: 'es'
    },
    {
        languageId: 'french',
        locale: 'fr',
        name: 'French',
        icon: 'fr'
    },
    {
        languageId: 'italian',
        locale: 'it',
        name: 'Italian',
        icon: 'it'
    },
    {
        languageId: 'saudi-arabia',
        locale: 'ar',
        name: 'Arabic',
        icon: 'sa'
    }*/

];
export default languageData;
